import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { CartActionTypes } from './types'
import { getDiscountSuccess, getDiscountError } from './actions'
import { CartUtil } from '../../utils/cartUtil';
import { Table } from '../interface'

const cartUtil: CartUtil = new CartUtil();

const getDiscountAPI = async(doc: any) => {
  return await cartUtil.GetDiscount(doc); 
}

function* handleUserDiscountRequest(action: any){
  try {
    // Must pass in ID in keyValues
    const res = yield call(getDiscountAPI, action.payload);
    if (res.isSuccess) {
      yield put(getDiscountSuccess(res.doc))
    } else {
      yield put(getDiscountError({"error" : res.errors}));
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(getDiscountError({"error" : err.stack}));
    } else {
      yield put(getDiscountError({"error" : "An unknown error occured: " +  err.stack}));
    }
  }
}

function* watchUserDiscountRequest() {
  yield takeEvery(CartActionTypes.GETDISCOUNT_REQUEST, handleUserDiscountRequest)
}

function* CartsSaga() {
  yield all([
    fork(watchUserDiscountRequest)
  ]);
}

export default CartsSaga
